import Product from 'components/admin/Products/Product'
import ProductBrowser from 'components/admin/Products/Segments/ProductBrowser'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import path from 'path'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { destroy } from 'redux-form'
import { loadPathLeaves, loadProductCategories } from 'redux/categories'
import { loadKeywords } from 'redux/keywords'
import { confirmationModal, setDirtyFormState } from 'redux/navigation'
import {
  clearProduct,
  disableForm,
  initializeDetailForm,
  loadProducts,
} from 'redux/product'
import { loadProperties } from 'redux/properties'
import { loadUsers } from 'redux/userAdmin'
import { Grid } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { dirtyForm } = state.navigation
  return { dirtyForm }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadProducts,
      loadPathLeaves,
      loadProductCategories,
      loadKeywords,
      loadProperties,
      loadUsers,
      destroy,
      initializeDetailForm,
      disableForm,
      clearProduct,
      confirmationModal,
      push,
      setDirtyFormState,
    },
    dispatch
  )
}

class Products extends React.Component {
  componentWillReceiveProps(nextProps) {
    const {
      initializeDetailForm,
      match: { params: oldParams = {} },
    } = this.props
    const {
      match: { params: newParams = {} },
    } = nextProps
    const { article_number: oldArticleNumber } = oldParams
    const { article_number: newArticleNumber } = newParams
    if (newArticleNumber && newArticleNumber !== oldArticleNumber)
      initializeDetailForm(newArticleNumber)
  }

  componentWillMount() {
    const {
      loadProducts,
      loadPathLeaves,
      loadProductCategories,
      loadKeywords,
      loadProperties,
      loadUsers,
      clearProduct,
      setDirtyFormState,
    } = this.props
    loadProducts()
    loadPathLeaves()
    loadProductCategories()
    loadKeywords()
    loadProperties()
    loadUsers()
    setDirtyFormState(false)

    const {
      initializeDetailForm,
      match: { params = {} },
    } = this.props
    const { article_number } = params
    if (article_number) {
      initializeDetailForm(article_number)
    } else {
      clearProduct()
    }
  }

  render() {
    const {
      push,
      dirtyForm,
      confirmationModal,
      setDirtyFormState, //connect
      location, //withRouter
    } = this.props //redux

    const browserProps = {
      onSelect: (article_number) => {
        if (dirtyForm) {
          confirmationModal({
            icon: config.icons.delete,
            negative: true,
            title: I18n.t('admin.product.browser.leaveModal.title'),
            text: I18n.t('admin.product.browser.leaveModal.text'),
            button: I18n.t('admin.product.browser.leaveModal.button'),
            // TODO: fix trailing slash bug
            confirm: () => {
              const newPath =
                path.basename(location.pathname) === 'product'
                  ? `${location.pathname}/${article_number}`
                  : `${path.dirname(location.pathname)}/${article_number}`
              push(newPath)
              setDirtyFormState(false)
            },
          })
        } else {
          const newPath =
            path.basename(location.pathname) === 'product'
              ? `${location.pathname}/${article_number}`
              : `${path.dirname(location.pathname)}/${article_number}`
          push(newPath)
          setDirtyFormState(false)
        }
      },
    }

    return (
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column
            computer={12}
            largeScreen={12}
            widescreen={3}
            className="stacked top up-to-largeScreen">
            <ProductBrowser {...browserProps} newFamily />
          </Grid.Column>
          <Grid.Column computer={12} largeScreen={12} widescreen={9}>
            <Product />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

Products = connect(mapStateToProps, mapDispatchToProps)(Products)
export default withRouter(Products)



// WEBPACK FOOTER //
// ./src/containers/admin/products.jsx